/**
 * Candidate reviews / testimonials for the Kandidatenfeedback page.
 * Realistic feedback from healthcare candidates (German).
 */
export const CANDIDATE_REVIEWS = [
  {
    quote:
      "Sehr professionelle und diskrete Begleitung. Ich wurde nur mit passenden Positionen angesprochen und konnte in Ruhe entscheiden. Der Wechsel hat sich gelohnt.",
    name: "Dr. Sarah M.",
    role: "Fachärztin Innere Medizin",
  },
  {
    quote:
      "Endlich eine Personalberatung, die die Branche versteht. Von der ersten Kontaktaufnahme bis zur Vertragsunterzeichnung – alles transparent und auf Augenhöhe.",
    name: "Thomas K.",
    role: "Leitender Oberarzt",
  },
  {
    quote:
      "Ich war zunächst skeptisch, ob Headhunting das Richtige für mich ist. Das Team hat alle Fragen beantwortet und mich nie unter Druck gesetzt. Sehr empfehlenswert.",
    name: "Dr. Julia W.",
    role: "Fachärztin Radiologie",
  },
  {
    quote:
      "Schnelle Reaktion, klare Kommunikation und ehrliches Feedback. Die Vermittlung zu meiner jetzigen Stelle lief reibungslos. Danke an das gesamte Team.",
    name: "Michael R.",
    role: "Abteilungsleiter Medizintechnik",
  },
  {
    quote:
      "Diskretion wurde großgeschrieben – mein Arbeitgeber hat erst davon erfahren, als ich mich für den Wechsel entschieden hatte. Genau so stelle ich mir seriöses Recruiting vor.",
    name: "Dr. Anna B.",
    role: "Fachärztin Anästhesie",
  },
  {
    quote:
      "Nach mehreren Jahren in derselben Klinik wollte ich eine neue Herausforderung. REPEXO hat die passende Position gefunden und den Prozess sehr gut begleitet.",
    name: "Stefan H.",
    role: "Oberarzt Chirurgie",
  },
  {
    quote:
      "Unkompliziert, kompetent und menschlich. Die Beraterin hat sich Zeit genommen und mir wirklich zugehört. Das Ergebnis hat meine Erwartungen übertroffen.",
    name: "Dr. Lisa F.",
    role: "Fachärztin Pädiatrie",
  },
  {
    quote:
      "Ich habe mich initiativ beworben und wurde innerhalb von wenigen Wochen mit zwei passenden Optionen konfrontiert. Die Auswahl blieb immer bei mir.",
    name: "Christoph D.",
    role: "Bereichsleiter Pharma",
  },
  {
    quote:
      "Fair, transparent und ohne versteckte Kosten. Als Kandidat fühlt man sich ernst genommen. Ich würde wieder mit REPEXO zusammenarbeiten.",
    name: "Dr. Petra S.",
    role: "Fachärztin Gynäkologie",
  },
  {
    quote:
      "Der Wechsel in eine neue Klinik war ein großer Schritt. Die Begleitung durch Vorstellungsgespräche und Vertragsverhandlung hat mir sehr geholfen.",
    name: "Markus L.",
    role: "Chefarzt Stellvertreter",
  },
  {
    quote:
      "Kompetente Beratung und ein starkes Netzwerk im Gesundheitswesen. Die vermittelte Position entspricht genau dem, was ich mir vorgestellt hatte.",
    name: "Dr. Nina K.",
    role: "Fachärztin Neurologie",
  },
  {
    quote:
      "Von Anfang an auf Augenhöhe. Kein Verkaufsdruck, sondern ehrliches Interesse an meiner Situation und meinen Zielen. Selten so professionell erlebt.",
    name: "Andreas P.",
    role: "Medizinischer Direktor",
  },
  {
    quote:
      "Die Vertragsverhandlung wurde von REPEXO sensibel begleitet. Ich habe mich gut aufgehoben gefühlt und bin mit dem Ergebnis sehr zufrieden.",
    name: "Dr. Claudia T.",
    role: "Fachärztin Dermatologie",
  },
  {
    quote:
      "Schnelle und unkomplizierte Abwicklung. Ich wurde nur mit Stellen konfrontiert, die wirklich zu meinem Profil passten. Keine Zeitverschwendung.",
    name: "Frank M.",
    role: "Leitung Qualitätsmanagement",
  },
  {
    quote:
      "Als ich angesprochen wurde, war ich zunächst unsicher. Das Beratungsgespräch hat alle Fragen geklärt. Heute bin ich froh über den Wechsel.",
    name: "Dr. Sandra G.",
    role: "Oberärztin Kardiologie",
  },
];
